module.exports = __webpack_public_path__ + "assets/clapping_hands.bbadacf023dc79b6c39970a3dfbbb40a920b0c7c30d9709041476a184a5fd0ae.png";